import { Text } from '@/components'
import { createStyles } from '@codeleap/styles'

export const ChatPreviewMention = ({ unreadMentions }: { unreadMentions: number }) => {

  if (unreadMentions === 0) return null

  return (
    <Text text='@' style={styles.text} />
  )
}

const styles = createStyles(theme => ({
  text: {
    fontSize: 16,
    fontWeight: '600',
    color: theme.baseColors.primarySolid500,
    lineHeight: '20px',
  },
}))
